import { fg } from '@atlassian/jira-feature-gating';
import { getMaxTokenLength } from '../../../../common/utils/token-browser-utils.tsx';

const createMediaContextFragment = () => `mediaContext(issueKey: $issueKey) {
    		${
					fg('dfo_remove_mediacontext_usertoken_from_iviq') // FG reused to control the presence of the mediaContext data
						? ''
						: `userToken {
					token
					id
					issueId
					tokenDurationInMins
				}`
				}
			${
				fg('dfo_remove_mediacontext_usertoken_from_iviq') // FG reused to control the presence of the mediaContext data
					? ''
					: `uploadToken {
						__typename
						... on MediaUploadToken {
							endpointUrl
							token
							targetCollection
							tokenDurationInMins
							clientId
						}
						... on FailedMediaUploadToken {
							error
						}
    				}`
			}
    readToken(maxTokenLength: ${getMaxTokenLength()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

export default createMediaContextFragment;
